import { ExerciseInterface, ObjectiveInterface } from "../../../interfaces/examInterfaces";

export const PRINT_TYPES = {
  IS_CREATING_ALL_PAGES: "isCreatingAllPages",
  ALL_PAGES: "allPages",
  ALL_TOTAL_POINTS: "allTotalPoints",
  IS_CREATING_PDF: "isCreatingPdf",
  IS_CREATING_PDF_SOLUTIONS: "isCreatingPdfSolutions",
  ALL_OBJECTIVES: "allObjectives",
  CURRENT_OBJECTIVE_INDEX: "currentObjectiveIndex",
  PRINT_SOLUTIONS: "printSolutions",
  CREATE_PAGE_NUMBERS: "createPageNumbers",
};

export const PRINT_INITIAL_STATE: PrintState = {
  isCreatingAllPages: false,
  allPages: [],
  allTotalPoints: [],
  isCreatingPdf: false,
  isCreatingPdfSolutions: false,
  allObjectives: [],
  currentObjectiveIndex: 0,
  printSolutions: true,
  createPageNumbers: true,
};

export interface PrintState {
  isCreatingAllPages: boolean;
  allPages: ExerciseInterface[][][];
  allTotalPoints: number[];
  isCreatingPdf: boolean;
  isCreatingPdfSolutions: boolean;
  allObjectives: ObjectiveInterface[];
  currentObjectiveIndex: number;
  printSolutions: boolean;
  createPageNumbers: boolean;
}

export interface Action {
  type: string;
  payload: any;
}

export const printReducer = (state = PRINT_INITIAL_STATE, action: Action): PrintState => {
  switch (action.type) {
    case PRINT_TYPES.IS_CREATING_ALL_PAGES:
      return { ...state, isCreatingAllPages: action.payload };

    case PRINT_TYPES.ALL_PAGES:
      return { ...state, allPages: action.payload };

    case PRINT_TYPES.ALL_TOTAL_POINTS:
      return { ...state, allTotalPoints: action.payload };

    case PRINT_TYPES.IS_CREATING_PDF:
      return { ...state, isCreatingPdf: action.payload };

    case PRINT_TYPES.IS_CREATING_PDF_SOLUTIONS:
      return { ...state, isCreatingPdfSolutions: action.payload };

    case PRINT_TYPES.ALL_OBJECTIVES:
      return { ...state, allObjectives: action.payload };

    case PRINT_TYPES.CURRENT_OBJECTIVE_INDEX:
      return { ...state, currentObjectiveIndex: action.payload };

    case PRINT_TYPES.PRINT_SOLUTIONS:
      return { ...state, printSolutions: action.payload };

    case PRINT_TYPES.CREATE_PAGE_NUMBERS:
      return { ...state, createPageNumbers: action.payload };

    default:
      return state;
  }
};
